<template>
  <div class="row" id="beginnerComponent">
    <div id="overlay" style="display:none; position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); z-index:5000; justify-content: center; align-items: center;">
      <div style="text-align: center; font-size: 24px; color: white;">Consultando a la IA...</div>
    </div>
    <div class="col s12 m6">
      <div class="col s12 m12">
        <h5>{{ $t('beginner.title') }}</h5>
        <a class="btn btn-outline-success w-10 mb-2 purple darken-4"  @click="consejo()">{{ $t('beginner.askAI') }}</a>
        <p v-if="aiAnswer"><span style="font-size:medium">{{ aiAnswer }}</span></p>
      </div>
      <!-- <div class="col s12 m6 right-align" style="padding:30px">
        
      </div>-->
      
      <md-tabs :active.sync="activeTab">
        <md-tab name="lessons" class="s4">
          <a :class="activeTab === 'lessons' ? 'indicatorTab' : ''">{{ $t('beginner.lessons') }}</a>
        </md-tab>
        <md-tab name="exercises" class="s4">
          <a :class="activeTab === 'exercises' ? 'indicatorTab' : ''">{{ $t('beginner.exercises') }}</a>
        </md-tab>
        <md-tab name="practice" class="s4">
          <a :class="activeTab === 'practice' ? 'indicatorTab' : ''">{{ $t('beginner.practice') }}</a>
        </md-tab>
        
        <div slot="contents">
          <div v-show="activeTab === 'lessons'" class="scrollable">
            <md-collection>
              <md-collection-item v-for="lesson in lessons" :key="lesson._id" :class="lesson._id === lessonTypeSelected ? 'active hightlight':'hightlight'" @click="openLesson(lesson)" class="clickable">
                <span><b>{{ lesson.lesson.toUpperCase() }}</b><md-badge style="min-width: 0rem;">{{ lesson.category }}</md-badge></span>
              </md-collection-item>
            </md-collection>
          </div>
          <div v-show="activeTab === 'exercises'" class="scrollable">
            <md-collection>
              <md-collection-item v-for="puzzle in puzzles" :key="puzzle._id" :class="puzzle._id === puzzleTypeSelected ? 'active hightlight':'hightlight'" @click="openPuzzle(puzzle)" class="clickable">
                <span><b>{{ puzzle.titlefen }}</b></span>
                  <!-- <md-badge style="min-width: 0rem;">{{ puzzle.type }}</md-badge></span>-->
              </md-collection-item>
            </md-collection>
          </div>
          <div v-show="activeTab === 'practice'" class="scrollable">
            <md-collection>
              <md-collection-item v-for="practice in practices" :class="practice._id === practiceTypeSelected ? 'active hightlight':'hightlight'" :key="practice._id" @click="openPractice(practice)" class="clickable">
                <span><b>{{ practice.titlefen }}</b></span>
              </md-collection-item>
            </md-collection>
          </div>
        </div>
      </md-tabs>
      <div class="col s12" style="margin-top:20px; padding-left:0;">
        <p v-if="aiCuriosity"><h5><strong>{{ $t('beginner.curiosity') }}:</strong></h5> <span style="font-size:medium">{{ aiCuriosity }}</span></p>
      </div>
    </div>
    <div class="col s12 m6">
      <div v-if="boardViewType === 'lesson'">
        <board-visor :board="boardView" :classboard="classBoard"></board-visor>
      </div>
      <div v-if="boardViewType === 'puzzle'">
        <puzzle-chess
          v-if="boardViewType === 'puzzle' && boardView"
          :key="'puzzle-' + boardView._id"
          :puzzle="boardView"
          :titlefen="$t('beginner.exercises')"
          :classboard="classBoard">
        </puzzle-chess>
      </div>
      <div v-if="boardViewType === 'practice'">
        <practice-chess
          v-if="boardViewType === 'practice' && boardView"
          :key="'practice-' + boardView._id"
          :puzzle="boardView"
          :titlefen="$t('beginner.practice')"
          :classboard="classBoard">
        </practice-chess>
      </div>
    </div>
  </div>
</template>
<script>
import Board from '../../services/board'
import PuzzleService from '../../services/puzzle'
import Store from '../../services/lstorage'
import { generateText } from '../../services/openaiutils'
import BoardVisor from '../home/boardVisor'
import PuzzleChess from '../puzzles/puzzle'
import PracticeChess from '../practice/puzzle'
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      lessons: [],
      puzzles: [],
      practices: [],
      aiAnswer: '',
      aiCuriosity: '',
      activeTab: 'lessons',
      boardView: null,
      boardViewType: '',
      lessonTypeSelected: '',
      puzzleTypeSelected: '',
      practiceTypeSelected: '',
      stylesBoard: {
        board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
        pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
      },
      styles: Store.get('styleBoard', { board: 0, pieces: 0 }),
      classBoard: ''
    }
  },
  components: {
    BoardVisor,
    PuzzleChess,
    PracticeChess
  },
  methods: {
    loadData () {
      Board.filterlesson(this, {
        filters: { u1: '', u2: '', name: '' },
        limit: 20,
        skip: 0,
        lessontype: 'Iniciación'
      }).then(r => {
        const d = JSON.parse(r)
        this.lessons = d.documents || []
      })
      PuzzleService.get(this, { type: 'Iniciacion' }).then(r => {
        const d = JSON.parse(r)
        this.puzzles = d || []
      })
      PuzzleService.get(this, { type: 'Practica0' }).then(r => {
        const d = JSON.parse(r)
        this.practices = d || []
      })
    },
    habilitarBotones () {
      if (document.getElementById('overlay')) {
        document.getElementById('overlay').style.display = 'none'
        const chatQuestion = document.getElementById('aiquestion')
        if (chatQuestion) {
          // window.alert(chatQuestion.value)
          chatQuestion.value = ''
        }
      }
    },
    deshabilitarBotones () {
      if (document.getElementById('overlay')) {
        document.getElementById('overlay').style.display = 'block'
      }
    },
    askAI () {
      generateText('¿Cómo se mueven las piezas de ajedrez?', '', 12).then(d => {
        // this.aiAnswer = d.choices ? d.choices[0].message.content : ''
      })
      // this.$broadcast('modal::open', 'modalIA')
    },
    openLesson (lesson) {
      this.boardViewType = 'lesson'
      this.boardView = lesson
      this.lessonTypeSelected = lesson._id
      generateText(
        'Eres un asistente de ajedrez que introduce lecciones para niños principiantes. Cuando se te indique una lección, responde con una única frase breve que la introduzca de forma clara y motivadora. No añadas explicaciones, no repitas frases anteriores y no des contexto. Solo responde con una frase llamativa que resuma o despierte interés por la lección. La lección es: ' + lesson.lesson,
        '',
        12
      ).then(d => {
        const msg = d.choices ? d.choices[0].message.content : ''
        this.aiAnswer = msg
        setTimeout(function () {
          const buttonFirst = document.getElementById('pgnButtonsfirst')
          if (buttonFirst) buttonFirst.click()
          window.dispatchEvent(new window.Event('resize'))
        }, 200)
        /* setTimeout(function () {
          const buttonPlay = document.getElementById('pgnButtonsplay')
          if (buttonPlay) buttonPlay.click()
          window.dispatchEvent(new window.Event('resize'))
        }, 200) */
      })
    },
    openPuzzle (puzzle) {
      this.boardViewType = 'puzzle'
      this.boardView = puzzle
      this.puzzleTypeSelected = puzzle._id
      // window.alert(JSON.stringify(this.boardView))
      generateText(
        'El ejercicio es: ' + this.boardView.titlefen + ' Y el fen es: ' + this.boardView.fen + '. Eres un asistente de ajedrez que introduce lecciones para principiantes. Cuando se te indique un ejercicio, responde con una única frase breve que la introduzca de forma clara y motivadora. No añadas explicaciones, no repitas frases anteriores y no des contexto. Solo responde con una frase llamativa que resuma o despierte interés por el ejercicio.',
        '',
        12
      ).then(d => {
        const msg = d.choices ? d.choices[0].message.content : ''
        this.aiAnswer = msg
      })
      /* generateText('Consejo para el ejercicio ' + puzzle.name + 'PGN: ' + puzzle.pgn, '', 12).then(d => {
        const msg = d.choices ? d.choices[0].message.content : ''
        Swal.fire({ html: msg, confirmButtonText: 'Empezar' }).then(() => {
          this.boardView = puzzle
          this.boardViewType = 'puzzle'
        })
      }) */
    },
    consejo () {
      this.deshabilitarBotones()
      generateText('Consejo para la práctica de ' + this.boardView.titlefen + '. Dame toda la información en html para mostrarla en un modal.', '', 12).then(d => {
        const msg = d.choices ? d.choices[0].message.content : ''
        this.habilitarBotones()
        Swal.fire({
          html: msg,
          confirmButtonText: 'Empezar',
          width: 420,              // modal compacto
          heightAuto: false,       // evita que fuerce altura al contenido
          scrollbarPadding: false, // evita “saltos” por la barra
          didOpen: (el) => {
            const c = el.querySelector('.swal2-html-container')
            if (c) {
              c.style.maxHeight = '52vh'   // límite vertical
              c.style.overflowY = 'auto'   // scroll interno
              c.style.textAlign = 'left'
              c.style.paddingRight = '8px' // espacio para la barra
            }
            // si tu HTML trae imágenes anchas, que no rompan el layout:
            const imgs = el.querySelectorAll('.swal2-html-container img')
            imgs.forEach(img => { img.style.maxWidth = '100%'; img.style.height = 'auto' })
          }
        })
      })
    },
    openPractice (practice) {
      this.boardView = practice
      this.boardViewType = 'practice'
      this.practiceTypeSelected = practice._id
    }
  },
  created () {
    this.loadData()
    this.classBoard = this.stylesBoard['board'][this.styles['board']] +
      ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']]
    // var randomSeed = Math.floor(Math.random() * 1000)
    generateText(
      `Eres un generador de tarjetas educativas de ajedrez. Debes responder con una sola frase que sea: una curiosidad sobre el ajedrez, un hecho sorprendente o divertido de la historia del ajedrez, o una frase célebre de algúún ajedrecista. La frase debe ser breve, clara, asombrosa y fácil de entender. Escríbela como si fuera para una tarjeta de motivación o aprendizaje. No añadas explicaciones. El tema de la frase es '${this.aiAnswer}', y no des contexto. Solo responde con la frase en una línea. Genera una curiosidad única según el segundo actual para evitar repeticiones.`,
      '',
      12
    ).then(d => {
      this.aiCuriosity = d.choices ? d.choices[0].message.content : ''
    })
  }
}
</script>
<style scoped>
.scrollable { max-height: 50vh; overflow-y: auto; list-style: disc; margin-left: 20px; }
.clickable { cursor: pointer; }
.tabs { overflow-x: hidden !important; overflow-y: hidden !important;}
.swal-small {
  max-height: 60vh; /* altura máxima */
  overflow: hidden; /* evita scroll fuera */
}

.swal-small .scroll-content {
  max-height: 50vh; /* limita el contenido */
  overflow-y: auto; /* activa scroll interno */
  text-align: left;
  padding-right: 10px;
}
/* Global (no-scoped) */
.swal2-popup .swal2-html-container{
  max-height: 52vh;
  overflow-y: auto;
  text-align: left;
}
#beginnerComponent >>> cg-board square.move-dest { display: none; }
</style>



// WEBPACK FOOTER //
// index.vue?e9846960